import DesShareLibrarySearchResultsForUsersViewModel from 'viewmodel/DesShareLibrarySearchResultsForUsersViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesShareLibrarySearchResultsForUsers extends DesBaseCatalogAcc {
    constructor() {
        super(DesShareLibrarySearchResultsForUsersViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {};
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale'];
    }
}

if (!window.customElements.get('des-share-library-search-results-for-users')) {
    window.customElements.define('des-share-library-search-results-for-users',
    DesShareLibrarySearchResultsForUsers);
}
